import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { partnerBasicDetailEditSchema } from '../../../ValidationSchema';
import { Autocomplete, Button, Card, CardContent, CardHeader, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, Select, TextField } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { editPartnerBasicPreference, getAllPhysicalStatus, getHeight, getMaritualStatus } from '../../../../asiosConfig';
import Popup from '../../../Popup';
export const PartnerBasicDetailsEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [heights, setHeights] = useState([]);
  const [ages, setAges] = useState([]);
  const userProfileData = location.state?.userProfileData || {};
  const [maritalStatus, setMaritalStatus] = useState([]);
  const [physicalStatus, setPhysicalStatus] = useState([]);
  // const [eatingHabits, setEatingHabits] = useState([]);
  const [showHaveChildren, setShowHaveChildren] = useState(false);
  const [popupData, setPopupData] = useState({ open: false, type: '', message: '' });

  const handleClosePopup = () => {
    setPopupData({ ...popupData, open: false });
  };

  useEffect(() => {
    if (popupData.open) {
      const timer = setTimeout(() => {
        setPopupData(prev => ({ ...prev, open: false }));
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [popupData.open]);

  const maritalStatusArray = userProfileData.partnerMaritalStatus
    ? userProfileData.partnerMaritalStatus.split(',').map((item) => item.trim())
    : [];


  const formik = useFormik({
    initialValues: {
      partner_age_From: userProfileData.ageFrom || '',
      partner_age_To: userProfileData.ageTo || '',
      partnerHeightFrom: userProfileData.partnerHeightFrom || '',
      partnerHeightTo: userProfileData.partnerHeightTo || '',
      partnerMaritalStatus: maritalStatusArray,
      no_of_Children: userProfileData.partnerHaveChild || '',
      physicalStatus: userProfileData.partnerPhysicalStatus || '',
      // partnerEatingHabits: eatingHabitsArray,
      user_id: localStorage.getItem('user_id'),
      // tokan: localStorage.getItem('token'),
    },
    validationSchema: partnerBasicDetailEditSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const formattedValues = {
          ...values,
          partnerMaritalStatus: values.partnerMaritalStatus.join(','), // Convert back to string
        };
        const response = await editPartnerBasicPreference(formattedValues);
        if (response.status === 200 || response.status === 201) {
          setPopupData({ open: true, type: 'success', message: response.data.message });
          setTimeout(() => {
            navigate(-1);
          }, 3000);
        } else {
          setPopupData({ open: true, type: 'error', message: response.data.message });
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: 'Failed to submit form' });
        console.error('Failed to submit form', error);
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    const fetchHeight = async () => {
      try {
        const response = await getHeight();
        if (response.status === 200 || response.status === 201) {
          setHeights(response.data);
        } else {
          console.error('Failed to fetch height');
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    };


    const fetchMaritalStatus = async () => {
      try {
        const response = await getMaritualStatus();
        if (response.status === 200 || response.status === 201) {
          setMaritalStatus(response.data);
        } else {
          console.error('Failed to fetch marital status');
        }
      } catch (error) {
        setPopupData({ open: true, type: 'error', message: error.message || "An error occurred" });
      }
    };

    const fetchPhysicalStatus = async () => {
      try {
        const response = await getAllPhysicalStatus();
        if (response.status === 200 || response.status === 201) {
          setPhysicalStatus(response.data.data.physical_status);
        } else {
          console.error('Failed to fetch physical status');
        }
      } catch (error) {

      }
    }
    fetchPhysicalStatus();
    fetchHeight();
    fetchMaritalStatus();
    const ageArray = Array.from({ length: 83 }, (_, i) => i + 18);
    setAges(ageArray);
  }, []);

  useEffect(() => {
    const shouldShow = formik.values.partnerMaritalStatus.some(status => ['2', '3', '4', '5'].includes(status));
    setShowHaveChildren(shouldShow);
  }, [formik.values.partnerMaritalStatus]);
  return (
    <div className="col-lg-9 col-12">
      <Card className="editProfileBlock">
        <CardHeader
          avatar={<ArrowBackIcon sx={{ color: '#FF8008' }} onClick={() => navigate(-1)} />}
          title="Partner's Basic Details"
          subheader="Update your partner basic details"
          titleTypographyProps={{ sx: { color: '#FF8008', fontSize: '20px', fontWeight: '500' } }}
        />
        <CardContent>
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Partner Age From"
                  variant="outlined"
                  className="mb-3"
                  name="partner_age_From"
                  value={formik.values.partner_age_From}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.partner_age_From && Boolean(formik.errors.partner_age_From)}
                  helperText={formik.touched.partner_age_From && formik.errors.partner_age_From}
                >
                  <MenuItem value="">Select Age</MenuItem>
                  {ages.map(age => (
                    <MenuItem key={age} value={age}>
                      {age}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Partner Age To"
                  variant="outlined"
                  className="mb-3"
                  name="partner_age_To"
                  value={formik.values.partner_age_To}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.partner_age_To && Boolean(formik.errors.partner_age_To)}
                  helperText={formik.touched.partner_age_To && formik.errors.partner_age_To}
                >
                  <MenuItem value="">Select Age</MenuItem>
                  {ages.map(age => (
                    <MenuItem key={age} value={age}>
                      {age}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Partner Height From"
                  variant="outlined"
                  className="mb-3"
                  name="partnerHeightFrom"
                  value={formik.values.partnerHeightFrom}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.partnerHeightFrom && Boolean(formik.errors.partnerHeightFrom)}
                  helperText={formik.touched.partnerHeightFrom && formik.errors.partnerHeightFrom}
                >
                  <MenuItem value="">Select Height</MenuItem>
                  {heights.map((item) => (
                    <MenuItem key={item.id} value={item.height_id}>
                      {item.height}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Partner Height To"
                  variant="outlined"
                  className="mb-3"
                  name="partnerHeightTo"
                  value={formik.values.partnerHeightTo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.partnerHeightTo && Boolean(formik.errors.partnerHeightTo)}
                  helperText={formik.touched.partnerHeightTo && formik.errors.partnerHeightTo}
                >
                  <MenuItem value="">Select Height</MenuItem>
                  {heights.map((item) => (
                    <MenuItem key={item.id} value={item.height_id}>
                      {item.height}
                    </MenuItem>
                  ))}
                </TextField>
              </div>

              <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={maritalStatus}
                  className="mb-3"
                  getOptionLabel={(option) => option.status}
                  value={maritalStatus.filter((occ) =>
                    formik.values.partnerMaritalStatus.includes(String(occ.id))
                  )}
                  onChange={(event, newValue) => {
                    const selectedIds = newValue.map((item) => String(item.id));
                    if (selectedIds.includes('7')) {
                      // If '7' is selected, keep only '7'
                      formik.setFieldValue('partnerMaritalStatus', ['7']);
                    } else if (formik.values.partnerMaritalStatus.includes('7')) {
                      // If '7' is previously selected, remove it
                      const filteredIds = selectedIds.filter((id) => id !== '7');
                      formik.setFieldValue('partnerMaritalStatus', filteredIds);
                    } else {
                      // Otherwise, set the selected options
                      formik.setFieldValue('partnerMaritalStatus', selectedIds);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Marital Status"
                      variant="outlined"
                      error={
                        formik.touched.partnerMaritalStatus &&
                        Boolean(formik.errors.partnerMaritalStatus)
                      }
                      helperText={
                        formik.touched.partnerMaritalStatus &&
                        formik.errors.partnerMaritalStatus
                      }
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.status}
                        onDelete={() =>
                          formik.setFieldValue(
                            'partnerMaritalStatus',
                            formik.values.partnerMaritalStatus.filter(
                              (id) => id !== String(option.id)
                            )
                          )
                        }
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />

              </div>
              {showHaveChildren && (
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    select
                    label="Have Children"
                    variant="outlined"
                    className="mb-3"
                    name="no_of_Children"
                    value={formik.values.no_of_Children}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.no_of_Children && Boolean(formik.errors.no_of_Children)}
                    helperText={formik.touched.no_of_Children && formik.errors.no_of_Children}
                  >
                    <MenuItem value="">Select Have Children</MenuItem>
                    <MenuItem value="no">No</MenuItem>
                    <MenuItem value="yes">Yes</MenuItem>
                    <MenuItem value="doesnt_matter">Doesn't Matter</MenuItem>
                  </TextField>
                </div>
              )}
              <div className="col-md-6">
                <TextField
                  fullWidth
                  select
                  label="Physical Status"
                  variant="outlined"
                  className="mb-3"
                  name="physicalStatus"
                  value={formik.values.physicalStatus}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.physicalStatus && Boolean(formik.errors.physicalStatus)}
                  helperText={formik.touched.physicalStatus && formik.errors.physicalStatus}
                >
                  <MenuItem value="">Select Physical Status</MenuItem>
                  <MenuItem value="Normal">Normal</MenuItem>
                  <MenuItem value="Disabled">Disabled</MenuItem>
                  <MenuItem value="Doesn't Matter">Doesn't Matter</MenuItem>
                </TextField>
              </div>

              {/* <div className="col-md-6">
                <Autocomplete
                  multiple
                  options={eatingHabits}
                  className='mb-3'
                  getOptionLabel={(option) => option.Type}
                  value={eatingHabits.filter(eat => formik.values.partnerEatingHabits.includes(String(eat.id)))}
                  onChange={(event, newValue) => {
                    formik.setFieldValue('partnerEatingHabits', newValue.map((item) => String(item.id)));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Partner Eating Habits"
                      variant="outlined"
                      error={formik.touched.partnerEatingHabits && Boolean(formik.errors.partnerEatingHabits)}
                      helperText={formik.touched.partnerEatingHabits && formik.errors.partnerEatingHabits}
                    />
                  )}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip
                        label={option.Type}
                        onDelete={() => formik.setFieldValue('partnerEatingHabits', formik.values.partnerEatingHabits.filter(id => id !== String(option.id)))}
                        {...getTagProps({ index })}
                        key={option.id}
                      />
                    ))
                  }
                />
              </div> */}
            </div>

            {/* <div className="d-grid col-4 mx-auto mt-2"> */}
            <Button type="submit" variant="contained" sx={{ backgroundColor: '#FF8008' }}>
              {formik.isSubmitting ? 'Saving...' : 'Save Changes'}
            </Button>
            {/* </div> */}
          </form>
        </CardContent>
      </Card>

      <Popup
        open={popupData.open}
        type={popupData.type}
        message={popupData.message}
        onClose={handleClosePopup}
      />
    </div >
  )
}
